import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2d9bc1c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "欢迎使用云雀客服平台", -1))
const _hoisted_4 = {
  key: 0,
  class: "text"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("已阅读并同意 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("云雀客服用户协议、隐私条款")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_8 = {
  key: 0,
  class: "copy-right"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"24px 26px","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "请联系微信号：yunquekf001"),
  /*#__PURE__*/_createElementVNode("p", null, "我们将竭诚为您提供帮助！")
], -1))
const _hoisted_10 = { style: {"text-align":"center","border-top":"1px solid rgb(235, 237, 240)","color":"rgb(238, 10, 36)","height":"48px","line-height":"48px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 复制微信号 ")
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "加载中..."))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_van_cell_group, {
              id: "login-form",
              inset: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  clearable: "",
                  modelValue: _ctx.loginname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginname) = $event)),
                  label: "账号",
                  placeholder: "请输入账号"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  clearable: "",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  label: "密码",
                  type: "password",
                  placeholder: "请输入密码",
                  onKeydown: _withKeys(_ctx.manualLogin, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_checkbox, {
              modelValue: _ctx.isAgreedTerm,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAgreedTerm) = $event)),
              id: "term-checkbox",
              onChange: _ctx.changeReadTerm
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_router_link, { to: { name: 'TOS', query: { isMannual: true } } }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]),
            _createVNode(_component_van_button, {
              onClick: _ctx.manualLogin,
              loading: _ctx.isLogining,
              disabled: _ctx.isLogining,
              id: "login-btn",
              block: "",
              type: "primary",
              style: {"margin-top":"40px"}
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick", "loading", "disabled"]),
            _createElementVNode("a", {
              style: {"text-align":"center","margin-top":"40px","display":"inline-block"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAdvisorDialog = true))
            }, "联系客服"),
            (_ctx.showCopyright)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "沪ICP备16020673号-6A"))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_dialog, {
      show: _ctx.showAdvisorDialog,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAdvisorDialog) = $event)),
      "show-confirm-button": false
    }, {
      default: _withCtx(() => [
        _hoisted_9,
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _withDirectives(_createElementVNode("div", _hoisted_10, _hoisted_12, 512), [
            [_directive_clipboard, 'yunquekf001', "copy"],
            [_directive_clipboard, _ctx.closeAdvisorDialog, "success"]
          ])
        ], true)
      ]),
      _: 3
    }, 8, ["show"])
  ], 64))
}